


























































































































import { ref, defineComponent, onMounted, computed } from '@vue/composition-api';
import acknowledgementModal from '@/components/GenericModal.vue';
import store from '@/store';
import Apierrormessage from '@/components/Apierrormessage.vue';
import dayJs from 'dayjs';

export default defineComponent({
  name: 'Welcome',
  components: { acknowledgementModal, Apierrormessage },
  setup() {
    const renderReady = ref(false);
    const apiError = ref(false);
    const Acknowledgement = ref(false);
    const showModal = ref(false);
    const date = ref('June 23, 2021');
    const repositories = ref([]);
    onMounted(async () => {
      await store.dispatch('profile/getEmployeeProfile');
      renderReady.value = true;
    });
    const skillsEmployeeProfile = computed(() => store.getters['profile/skillsEmployeeProfile']);
    const formatDate = (value: any) => {
      if (value) {
        return dayJs(String(value)).format('MMM DD YYYY');
      }
      return '';
    };
    const numberOfCheckboxesSelected = () => {
      const checkedOne = document.querySelectorAll('input[type=checkbox][name="Acknowledgement"]:checked').length;
      if (checkedOne === 1) {
        Acknowledgement.value = true;
      } else {
        Acknowledgement.value = false;
      }
    };
    return {
      skillsEmployeeProfile,
      date,
      Acknowledgement,
      numberOfCheckboxesSelected,
      showModal,
      renderReady,
      apiError,
      repositories,
      formatDate,
    };
  },
});
